// Module
var code = "<div class=panel-body-inner ng-transclude></div>";
// Exports
module.exports = code;